<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="Branding Configuration"
      :config-name="configName"
      :can-edit="canBrandingEdit"
      :can-publish="canBrandingPublish">
      <template slot="header" />
      <div
        v-if="config"
        class="mt-3 mb-4">
        <team-picker
          :config="config"
          @on-team-selected="onTeamSelected" />
        <b-btn
          v-if="selectedTeam"
          v-b-modal.team-info-modal
          variant="outline-primary"
          class="mx-2"
          @click="$refs.teamInfoModal.show()">
          Update Basic Team Info
        </b-btn>
      </div>
      <team-tabs
        v-if="selectedTeam"
        ref="teamTabs"
        v-model="config"
        :selected-team="selectedTeamRef"
        :component-key="componentKey " />
    </config-publisher>
    <edit-team-info-modal
      v-if="selectedTeamRef"
      :key="`team-info-modal-${selectedTeamRef.teamID}`"
      ref="teamInfoModal"
      v-bind="selectedTeamRef"
      @input="onUpdateTeamInfo" />
  </b-container>
</template>

<script>
  import {mapGetters} from "vuex"
  import TeamPicker from "../components/Branding/TeamPicker"
  import TeamTabs from "../components/Branding/TeamTabs"
  import ConfigPublisher from "@/components/ConfigPublisher"
  import EditTeamInfoModal from "@/components/Branding/EditTeamInfoModal"

  export default {
    name: "Branding",
    components: {
      EditTeamInfoModal,
      ConfigPublisher,
      TeamTabs,
      TeamPicker,
    },
    data: () => ({
      componentKey: 1,
      selectedTeam: null,
      config: {},
      betaConfig: null,
      prodConfig: null,
      betaUrl: "",
      prodUrl: "",
      configName: "branding",
    }),
    computed: {
      ...mapGetters([
        'betaEnvName',
        'liveEnvName',
        'isAdmin',
        'canBrandingEdit',
        'canBrandingPublish',
      ]),
      selectedTeamRef() {
        if (!this.selectedTeam || !this.config) {
          return null
        }

        const val = this.selectedTeam
        for (const [i, teamConfig] of this.config.teams.entries()) {
          if (teamConfig.clubFullName === val.clubFullName) {
            return this.config.teams[i]
          }
        }
        for (const [i, teamConfig] of this.config.allstarTeams.entries()) {
          if (teamConfig.clubFullName === val.clubFullName) {
            return this.config.allstarTeams[i]
          }
        }
        return this.config.mlb
      },
    },
    watch: {
      'config'() {
        if (this.config && this.config.teams) {
          // Sort the teams alphabetically by the clubFullName field, other than the Default team which should always be first.
          this.config.teams = this.config.teams.sort((a, b) => {
            if (a.clubFullName === "Default") return -1
            if (b.clubFullName === "Default") return 1
            return a.clubFullName.localeCompare(b.clubFullName)
          })
        }
      },
    },
    async beforeRouteLeave(to, from, next) {
      if (this.$refs.configPublisher.configHasChanged()) {
        const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
        next(await this.$confirm.open(message))
      } else {
        next()
      }
    },
    methods: {
      onTeamSelected(newValue) {
        this.selectedTeam = newValue
      },
      onUpdateTeamInfo(updatedConfig) {
        if (!this.selectedTeam || !this.selectedTeamRef) {
          return
        }
        Object.assign(this.selectedTeamRef, updatedConfig)
      },
    },
  }
</script>
